import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAadhaarOnly]'
})
export class AadhaarFormatDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  private maxLength = 12;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
    ];
    if (allowedKeys.includes(event.key)) return;

    // Only allow digits
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }

    // Prevent typing more than 12 digits
    if (this.el.nativeElement.value.length >= this.maxLength) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    // Allow only digits and max 12 characters
    const currentLength = this.el.nativeElement.value.length;
    if (!/^\d+$/.test(pasted) || (currentLength + pasted.length) > this.maxLength) {
      event.preventDefault();
    }
  }

  // @HostListener('input', ['$event'])
  // onInput() {
  //   const input = this.el.nativeElement;
  //   // Remove all non-digit characters
  //   let cleaned = input.value.replace(/\D+/g, '');
  //   // Trim to max 12 digits
  //   if (cleaned.length > this.maxLength) {
  //     cleaned = cleaned.substring(0, this.maxLength);
  //   }
  //   if (input.value !== cleaned) {
  //     input.value = cleaned;
  //     // Dispatch input event to update Angular form control
  //     input.dispatchEvent(new Event('input', { bubbles: true }));
  //   }
  // }
}
